const offcanvasdialog = require('../components/offcanvasdialog');

/**
 *
 */
function initOffCanvasDialog() {
    offcanvasdialog.init(
        'fylin-link-ingredients',
        {
            overlay: true,
            reloadContentAlways: true,
            closeOnX: true,
            additionalClass: 'fly-in-dialogue-avaliability'
        },
        function ($triggerButton, $flyinContainer) {
            $flyinContainer.find('.button.close').on(
                'click',
                function (event) {
                    event.preventDefault();
                    this.hide();
                }.bind(this)
            );
        }
    );
}

/**
 *
 */
exports.init = function () {
    initOffCanvasDialog();
};
